module.exports = __webpack_public_path__ + "static/media/sea.731cddd8.svg";